import React from 'react';
import { compose } from 'redux';
import PageView from 'hoc/PageView';
import AuthTemplateContainer from 'containers/AuthTemplateContainer';

import ResetPasswordForm from 'components/organisms/forms/ResetPassword';

const ResetPasswordPage = () => (
    <AuthTemplateContainer>
        <ResetPasswordForm />
    </AuthTemplateContainer>
);

export default compose(
    PageView({ page: 'Viewed Reset Password Screen' })
)(ResetPasswordPage);




// WEBPACK FOOTER //
// ./src/components/pages/ResetPassword.js